const STATE_GROUPS = {
  inProcess: {
    key: 'inProcess',
    color: 'success',
    icon: 'fa-play-circle',
    labelKey: 'general.flow-engine.semaphore.in-process',
    defaultLabel: 'En Proceso',
    names: ['En Proceso', 'Guardado', 'Borrador']
  },
  pending: {
    key: 'pending',
    color: 'warning',
    icon: 'fa-pause-circle',
    labelKey: 'general.flow-engine.semaphore.pending',
    defaultLabel: 'Pendiente',
    names: ['Pendiente']
  },
  licenseWait: {
    key: 'licenseWait',
    color: 'warning',
    icon: 'fa-hourglass-half',
    labelKey: 'general.flow-engine.semaphore.license-wait',
    defaultLabel: 'En verificación de licencia',
    names: ['En verificación de licencia']
  },
  expertWait: {
    key: 'expertWait',
    color: 'expert',
    icon: 'fa-user-md',
    styleColor: '#8B5A2B',
    labelKey: 'general.flow-engine.semaphore.expert-wait',
    defaultLabel: 'En consulta a experto',
    names: ['En consulta a experto']
  },
  published: {
    key: 'published',
    color: 'primary',
    icon: 'fa-check-circle',
    labelKey: 'general.flow-engine.semaphore.published',
    defaultLabel: 'Publicado',
    names: ['Publicado', 'Aprobado']
  },
  eliminated: {
    key: 'eliminated',
    color: 'secondary',
    icon: 'fa-ban',
    labelKey: 'general.flow-engine.semaphore.eliminated',
    defaultLabel: 'Eliminado',
    names: ['Eliminado']
  },
  rejected: {
    key: 'rejected',
    color: 'danger',
    icon: 'fa-times-circle',
    labelKey: 'general.flow-engine.semaphore.rejected',
    defaultLabel: 'Rechazado',
    names: ['Rechazado']
  }
};

const normalizeName = (value = '') => String(value).trim().toLowerCase();

export const resolveFlowStateSemaphore = (stateCatalogId, flowStates = []) => {
  const state = (flowStates || []).find((item) => Number(item.id) === Number(stateCatalogId));
  const stateName = state?.name || '';

  const matchedGroup = Object.values(STATE_GROUPS).find((group) =>
    group.names.some((name) => normalizeName(name) === normalizeName(stateName))
  );

  if (matchedGroup) {
    return {
      ...matchedGroup,
      stateName: stateName || matchedGroup.defaultLabel,
      stateCatalogId
    };
  }

  return {
    key: 'unknown',
    color: 'secondary',
    icon: 'fa-circle-o',
    labelKey: 'general.flow-engine.unknown-state',
    defaultLabel: 'Sin estado',
    stateName: stateName || 'Sin estado',
    stateCatalogId
  };
};

export const getSemaphoreTitle = (semaphore, t) => {
  if (!semaphore) {
    return t('general.flow-engine.unknown-state', 'Sin estado');
  }
  return t(semaphore.labelKey, semaphore.defaultLabel);
};

export default STATE_GROUPS;
